import './styles/theme.css';
import './styles/app.css';
import { Engine } from './core/Engine';
import { App } from './ui/App';

const root = document.querySelector<HTMLElement>('#app');
if (!root) throw new Error('#app root not found');

const engine = new Engine();
const app = new App(root, engine);

// Wire the render loop: the engine calls back once per animation frame.
const { offlineMs, fresh, offlineSummary } = engine.init(() => app.frame());
app.mount(offlineMs, fresh, offlineSummary);

// Expose for debugging in the console.
(window as any).__mt = { engine, app };

// PWA: register the service worker for offline/installable support (prod only).
if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('./sw.js').catch(() => {/* offline support is best-effort */});
  });
}
